import {connect} from "react-redux"
import State from "../../ducks/state"
import {prefixImagePath} from "../../utils/prefixPath"

export type MissionItemProps = {
    imageUrl: string
    title: string
    department: string
}

export const mapStateToProps = (state: State, ownProps: MissionItemProps) => {
    const imageUrl: string = prefixImagePath(state.request.siteUrl)(ownProps.imageUrl)
    const {siteUrl, cleanSiteUrl} = state.request
    const {rememberSelectedDepartment, isTpSuperLite} = state.settings

    return {
        ...ownProps,
        url: isTpSuperLite ? cleanSiteUrl : siteUrl,
        imageUrl,
        rememberSelectedDepartment,
        templating: state.template,
    }
}

export default connect(mapStateToProps)
